import type { QueryClient } from '@tanstack/react-query'

import { authKeys, type AuthState } from '@/api/auth'

import * as store from './store'

/** После разблокировки: сессия открыта — обновить состояние входа и данные, дослать очередь. */
export function afterUnlock(client: QueryClient): void {
  client.setQueryData<AuthState>(authKeys.state, (old) => ({
    setup_required: false,
    authenticated: true,
    lock_after_s: old?.lock_after_s ?? store.getLockAfter(),
    locked: false,
  }))
  void client.invalidateQueries({ predicate: (q) => q.queryKey[0] !== authKeys.state[0] })
}
